import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				useYn: searchParams.useYn,
				lgrpCd: searchParams.lgrpCd?.join(','),
				sgrpCd: searchParams.sgrpCd?.join(','),
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCku/v1/lists${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveData({ tymaCd, lgrpCd, sgrpCd }, param) {
		try {
			const pathVariables = `lgrpCd/${lgrpCd}/sgrpCd/${sgrpCd}`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCku/v1/status/2/${pathVariables}`, param, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async toggleUseYnRows(rows, useYn) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCku/v1/status/3/useYn/${useYn}`, rows);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 엑셀템플릿 다운로드
	async excelTempDown(params) {
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 구분 없이 한번에 공통 코드 부르기 */
	async getMergedCommCodesOnce(codes) {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/noCategoryLists?codes=${codes}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
